<template>
  <v-list-item-content
    v-if="(typeof value === 'string' && value.toLowerCase()) === '::restrict::'"
    class="ma-0 pa-0"
  >
    <v-list-item-title class="d-flex justify-lg-end" style="width: 1px">
      <div
        class="restrict-chip text-caption d-flex align-center"
        :title="$t('info_restrita_usuario')"
      >
        <v-card
          rounded
          color="transparent"
          elevation="0"
          style="padding: 0.01rem 0.2rem 0.01rem 0"
        >
          <v-icon size="10px" color="grey darken-0" class="mr-1"
            >mdi-lock</v-icon
          >
          <span
            style="font-size: 11px"
            class="grey--text text--darken-0 font-italic"
            >{{ $t("restrito") }}</span
          >
        </v-card>
      </div>
    </v-list-item-title>
  </v-list-item-content>
  <v-list-item-content v-else class="ma-0 pa-0">
    <slot />
  </v-list-item-content>
</template>

<script>
export default {
  props: ["value"],
};
</script>
